import api from '../api.js';

// Requires observer.js
export default function (...args)
{

	let SHARED = { _this: null };

	return {
		async actions(ev, publisher, product_id)
		{
			let node = document.querySelector(this.selector);
			if (!node)
				return;
			node.setAttribute('placeholder', '');
			let company_id = this.locate('company_id').getValue();
			if (!company_id || company_id < 0 || !product_id || product_id < 0)
				return;
			let stocks = await api.call(api.list_stocks_by_product, company_id, product_id);
			if (!stocks)
				return;
			let quantity = stocks.reduce((accumulator, entry) => accumulator + entry.quantity_available, 0);
			node.setAttribute('placeholder', quantity);
		}

	};

}

